/* 記事内の価格表示を、Shopifyの現在価格に合わせて更新する。
 *  - 商品カード(.wba-card)内の .wba-card-price
 *  - 比較表などの [data-price-handle="<商品handle>"] 要素(セル内の「¥X,XXX〜」部分のみ置換)
 * 記事HTMLに書かれた価格は、取得失敗時(下書き・削除・通信エラー)のフォールバックとしてそのまま残る。
 * 対象は記事ページのみ(layout/theme.liquid 側で article テンプレートに限定して読み込み)。
 * 表示速度への配慮: ブラウザのアイドル時に実行し、取得結果は30分間 sessionStorage に保持して再取得を避ける。
 * 記事側の静的な価格は article_price_sync/price_sync.py が同じ規則(全variantが同額なら「〜」なし)で保守する。 */
(function () {
  'use strict';
  if (!window.fetch) return;

  var YEN = /¥[\d,]+〜?/;
  var TTL = 30 * 60 * 1000;
  var byHandle = {};
  function add(handle, el) { (byHandle[handle] = byHandle[handle] || []).push(el); }

  function cacheGet(handle) {
    try {
      var v = JSON.parse(sessionStorage.getItem('apsync:' + handle));
      return v && Date.now() - v.t < TTL ? v : null;
    } catch (e) { return null; }
  }
  function cacheSet(handle, min, varies) {
    try { sessionStorage.setItem('apsync:' + handle, JSON.stringify({ t: Date.now(), min: min, v: varies })); } catch (e) {}
  }
  function apply(handle, min, varies) {
    var text = '¥' + Math.round(min / 100).toLocaleString('ja-JP') + (varies ? '〜' : '');
    byHandle[handle].forEach(function (el) { el.textContent = el.textContent.replace(YEN, text); });
  }

  function run() {
    document.querySelectorAll('.wba-card').forEach(function (card) {
      var priceEl = card.querySelector('.wba-card-price');
      var link = card.querySelector('a[href*="/products/"]');
      if (!priceEl || !link || !YEN.test(priceEl.textContent)) return;
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m) add(m[1], priceEl);
    });
    document.querySelectorAll('[data-price-handle]').forEach(function (el) {
      if (YEN.test(el.textContent)) add(el.getAttribute('data-price-handle'), el);
    });

    Object.keys(byHandle).forEach(function (handle) {
      var c = cacheGet(handle);
      if (c) { apply(handle, c.min, c.v); return; }
      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          // 下書き・削除済みは404で null。JPYの .js は金額が100倍で返る
          if (!p || typeof p.price_min !== 'number') return;
          cacheSet(handle, p.price_min, !!p.price_varies);
          apply(handle, p.price_min, !!p.price_varies);
        })
        .catch(function () { /* 失敗時は記事の記載を維持 */ });
    });
  }

  function start() {
    if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 3000 });
    else setTimeout(run, 1500);
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
